<div class="space-y-4">

  <div class="flex justify-end">
    <button type="button" (click)="resetToDefaults()"
      class="inline-flex items-center gap-1 px-2.5 py-1 text-[11px] font-medium rounded-md text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 border border-gray-200 dark:border-gray-700 transition-colors">
      Restablecer
    </button>
  </div>

  <div class="grid grid-cols-2 gap-x-3 gap-y-4">

    @for (entry of colorEntries; track entry.key) {
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">{{ entry.label }}</label>
        <div class="flex items-center gap-1">
          <label class="relative cursor-pointer flex-1 h-8 rounded-lg border border-gray-200 dark:border-gray-700 ring-1 ring-black/10 overflow-hidden hover:border-gray-400 dark:hover:border-gray-500 transition-colors block"
            [style.backgroundColor]="simple[entry.key]">
            <input type="color"
              [ngModel]="simple[entry.key]"
              (ngModelChange)="simple[entry.key] = $event; onSimpleChange()"
              class="sr-only" />
          </label>
          @if (supportsEyeDropper) {
            <button type="button"
              (click)="openEyeDropper(entry.key)"
              [class.text-brand-500]="pickingKey === entry.key"
              [class.animate-pulse]="pickingKey === entry.key"
              class="p-1.5 rounded-md text-gray-400 hover:text-brand-500 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors flex-shrink-0"
              title="Tomar color de la pantalla">
              <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.71 5.63l-2.34-2.34a1 1 0 00-1.41 0l-3.12 3.12-1.41-1.42-1.42 1.42 1.41 1.41-6.6 6.6A2 2 0 005 16v3h3a2 2 0 001.42-.59l6.6-6.6 1.41 1.42 1.42-1.42-1.42-1.41 3.12-3.12a1 1 0 000-1.65zM8 17H7v-1l6.59-6.59 1 1z"/>
              </svg>
            </button>
          }
        </div>
      </div>
    }

    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Radio del borde · {{ simple.borderRadius ?? 0 }}px</label>
      <input type="range" min="0" max="24" step="1" [(ngModel)]="simple.borderRadius" (ngModelChange)="onSimpleChange()" class="w-full accent-brand-500" />
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Tamaño fuente · {{ simple.fontSize ?? 0 }}px</label>
      <input type="range" min="10" max="20" step="1" [(ngModel)]="simple.fontSize" (ngModelChange)="onSimpleChange()" class="w-full accent-brand-500" />
    </div>

    <div class="col-span-2">
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Tipografía</label>
      <select [(ngModel)]="simple.fontFamily" (ngModelChange)="onSimpleChange()"
        class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        @for (f of fontOptions; track f) {
          <option [ngValue]="f" [style.fontFamily]="f">{{ f }}</option>
        }
      </select>
    </div>

  </div>

  <!-- Preview -->
  <div>
    <p class="text-[10px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500 mb-1.5">Vista previa</p>
    <div class="p-4 border border-gray-200 dark:border-gray-700 rounded-xl"
      [style.backgroundColor]="simple.backgroundColor"
      [style.color]="simple.textColor"
      [style.fontFamily]="simple.fontFamily"
      [style.fontSize.px]="simple.fontSize">
      <p class="mb-2 text-xs" [style.color]="simple.labelColor">Tu nombre</p>
      <input type="text" placeholder="John Doe" readonly
        class="w-full px-3 py-2 mb-3 bg-white text-xs"
        [style.borderRadius.px]="simple.borderRadius"
        [style.border]="'1px solid ' + simple.borderColor"
        [style.color]="simple.textColor" />
      <button type="button" class="px-4 py-2 text-xs font-medium"
        [style.backgroundColor]="simple.primaryColor"
        [style.color]="simple.buttonTextColor"
        [style.borderRadius.px]="simple.borderRadius">
        Enviar
      </button>
    </div>
  </div>

</div>
